import { ElementType, forwardRef, HTMLAttributes } from "react";
import clsx from "clsx";

import styles from "./typography.module.scss";

type TypographyProps = {
  /** The HTML tag to use */
  tag?: ElementType;
  /** Optional extra class(es) */
  className: string;
  /** Set to true to remove the margins */
  noMargin?: boolean;
} & HTMLAttributes<HTMLElement>;

/** Typography is the super class of the other typography classes. It should not be used directly. */
const Typography = forwardRef<HTMLElement, TypographyProps>(
  ({ tag: Tag = "div", className = "", noMargin, ...rest }, ref) => {
    const classes = [{ [styles.typeNoMargin]: noMargin }, className];

    return <Tag ref={ref} {...rest} className={clsx(classes)} />;
  }
);

Typography.displayName = "Typography";

export default Typography;
